export enum PwaSyncModificationType {
    None = 0,
    Created = 1,
    Updated = 2,
    MediaUpdated = 3,
    Deleted = 4,
    Moved = 5	
}